<!--
    合同备忘
-->
<template>
    <div class="main">
        <div class="main-top">
            <!-- <div
                v-if="objAccount.is_change == 0"
                class="main-top-contract"
            >
                正式合同
            </div>
            <div v-else class="main-top-contract">项目变更</div>
            <div class="main-top-number">{{ objAccount.accountnumber }}</div>
            -->
            <div class="main-top-address">
                {{ objAccount.new_address }}
            </div>
            <div class="plan_lable">
                <p>{{ objAccount.new_area ? objAccount.new_area + ' m²' : '不详' }}</p>
                <p>
                    {{ objAccount.new_roomnumber ? objAccount.new_roomnumber + '室' : '' }}{{
                        objAccount.new_hall ? objAccount.new_hall + '厅' : ''
                    }}{{ objAccount.new_toilet ? objAccount.new_toilet + '卫' : '' }}{{
                        objAccount.new_kitchen ? objAccount.new_kitchen + '厨' : ''
                    }}
                </p>
                <p>{{ objAccount.new_housetype_name ? objAccount.new_housetype_name : '不详' }}</p>
            </div>
        </div>
        <div :class="['threeBox',{'threeBox2':isShowShare}]">
            <div class="title">3D设计方案</div>
            <iframe class="iframe" :src="url"></iframe>
        </div>
        <div class="home_icon" @click="goHome" :style="{bottom: isShowShare  ? '108px':'88px'}">
            <img src="~@/assets/images/processv2/tohome.png"/>
        </div>
        <share ref="myShare" v-if="isShowShare" :isFixed="true"></share>
    </div>
</template>


<script>
import share from "../components/share.vue"

export default {
    name: "designer3d",
    data() {
        return {
            objAccount: {},
            url: '',
            name: '',
            isShowShare: false
        };
    },
    components: {
        share
    },
    created() {
        this.$store.commit("loadSkeleton", {bool: true}); // 页面loading关闭
        $init(() => {
            this.$oInitData.designerInfo({
                h5_user_id: this.$storage.getStorage("user_id"),
            }).then((res) => {

                let objData = this.$route.query;
                if (objData.sampleroom == 2) {
                    this.isShowShare = true;
                }
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
                this.objAccount = this.$storage.getStorage('designer_account')
                this.url = this.$route.query.url;
            }).catch((error) => {
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
            });
        })
    },
    methods: {
        goHome() {
            this.$router.go(-2)
        }
    },
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
